// extracted by mini-css-extract-plugin
export default {"tabs":"Tabs_tabs__XT4GJ","tab":"Tabs_tab__wjy3G","selectedTab":"Tabs_selectedTab__+rnOg","active":"Tabs_active__oFX8q"};